import { Location, Sms } from 'iconsax-react';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { Phone } from 'react-feather';

import { language } from './language';
import {
  ContactInfoTabRoutesEnum,
  contactInfoTabRouteKeys,
  contactInfoTabRoutes,
} from './contactInfoTypes';

export const useContactInfoTabsConfig = (isMobile?: boolean) => {
  const pathname = usePathname();
  const isInRoot = pathname === `/${ContactInfoTabRoutesEnum.phone}`;

  const activeTab = useMemo(() => {
    const matched = contactInfoTabRoutes.find((route) => pathname.includes(`/${route}`));
    const route = matched ?? ContactInfoTabRoutesEnum.phone;
    return contactInfoTabRouteKeys[route];
  }, [pathname]);

  const tabsConfig = useMemo(
    () => [
      {
        id: 0,
        key: ContactInfoTabRoutesEnum.phone,
        href: isMobile
          ? `/${ContactInfoTabRoutesEnum.phone}/phone`
          : `/${ContactInfoTabRoutesEnum.phone}`,
        label: language.phone,
        dataTestId: 'contactinfo-tab-phone',
        icon: <Phone size={14} className='text-purple hover:text-blue-1' />,
        mobileIcon: (
          <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-purple'>
            <Phone color='#ffffff' size={18} />
          </div>
        ),
      },
      {
        id: 1,
        key: ContactInfoTabRoutesEnum.email,
        href: `/${ContactInfoTabRoutesEnum.email}`,
        label: language.email,
        dataTestId: 'contactinfo-tab-email',
        icon: <Sms size={14} className='text-turquoise hover:text-blue-1' />,
        mobileIcon: (
          <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-turquoise'>
            <Sms color='#ffffff' size={18} />
          </div>
        ),
      },
      {
        id: 2,
        key: ContactInfoTabRoutesEnum.address,
        href: `/${ContactInfoTabRoutesEnum.address}`,
        label: language.address,
        dataTestId: 'contactinfo-tab-address',
        icon: <Location size={14} className='text-orange hover:text-blue-1' />,
        mobileIcon: (
          <div className='flex h-[34px] w-[34px] items-center justify-center rounded-[6px] bg-orange'>
            <Location color='#ffffff' size={18} />
          </div>
        ),
      },
    ],
    [isMobile]
  );

  return { tabsConfig, activeTab, isInRoot };
};
